/**
 * Funzioni API per la gestione schedule Prefect (Admin — product-service proxy).
 *
 * Endpoint (tutti SYSTEM_CONFIGURATION):
 *   GET   /api/products/admin/prefect/deployments
 *   PATCH /api/products/admin/prefect/deployments/:id/schedule
 */

import { createServiceClient } from '../../api/client.js';
import type { PrefectDeployment, UpdateSchedulePayload } from './prefect-schedules-types.js';

const productApi = createServiceClient('product');

/** Lista i deployment Prefect con il loro schedule corrente. */
export function fetchPrefectDeployments(): Promise<PrefectDeployment[]> {
  return productApi<PrefectDeployment[]>('/admin/prefect/deployments');
}

/** Aggiorna lo schedule cron (e lo stato attivo) di un deployment. */
export function updateDeploymentSchedule(
  payload: UpdateSchedulePayload,
): Promise<{ name: string; cron: string; timezone: string; active: boolean }> {
  return productApi(`/admin/prefect/deployments/${encodeURIComponent(payload.id)}/schedule`, {
    method: 'PATCH',
    body: {
      name: payload.name,
      cron: payload.cron,
      timezone: payload.timezone ?? 'UTC',
      active: payload.active,
    },
  });
}
